import React from "react";
import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";
import { Tag } from "antd";
import Name from "./components/Name";
import AmountSummary from "./components/AmountSummary";

const getColumns = props => {
    const {
        reportData,
        getUrlFn,
        reportType, // 'aged_receivables/summary' or 'aged_payables/summary'
    } = props;

    const companyCurrencySymbol = reportData?.company?.currency_symbol;
    const periodLabels = reportData?.report?.period_labels || [];

    let displayNameTitle;
    switch (reportType) {
        case "aged_payables/summary":
            displayNameTitle = t`Supplier`;
            break;
        case "aged_receivables/summary":
            displayNameTitle = t`Customer`;
            break;
        default:
            displayNameTitle = t`Contact`;
            break;
    }

    return [
        {
            key: 'legal_name',
            dataKey: 'legal_name',
            title: displayNameTitle,
            width: 0,
            flexGrow: 20,
            sortable: true,
            cellRenderer: ({cellData, rowData}) => (
                <Name
                    text={cellData}
                    contactCode={rowData.contact_code}
                    record={rowData}
                    getUrlFn={getUrlFn}
                />
            ),
        },
        {
            key: 'contact_code',
            dataKey: 'contact_code',
            title: t`Contact Code`,
            width: 0,
            flexGrow: 10,
            sortable: true,
        },
        {
            key: 'term',
            dataKey: 'term',
            title: t`Payment Term`,
            width: 0,
            flexGrow: 10,
            cellRenderer: ({cellData}) => (cellData ? <Tag>{cellData}</Tag> : '-'),
        },
        {
            key: 'base_coming_due_amount',
            dataKey: 'base_coming_due_amount',
            title: t`Current`,
            width: 0,
            flexGrow: 12,
            align: 'right',
            sortable: true,
            cellRenderer: ({cellData}) => (
                <AmountSummary text={cellData} currencySymbol={companyCurrencySymbol} />
            ),
        },
        ...periodLabels.map((item, idx) => ({
            key: `base_period${idx}_amount`,
            dataKey: `base_period${idx}_amount`,
            title: item,
            width: 0,
            flexGrow: 12,
            align: 'right',
            sortable: true,
            cellRenderer: ({rowData}) => (
                <AmountSummary
                    text={rowData.base_period_amounts[idx]}
                    currencySymbol={companyCurrencySymbol}
                />
            ),
        })),
        {
            dataKey: 'base_total_amount',
            key: 'base_total_amount',
            title: t`Total`,
            align: 'right',
            sortable: true,
            width: 0,
            flexGrow: 15,
            cellRenderer: ({cellData}) => (
                <strong className="full-width">
                    <AmountSummary
                        text={cellData}
                        isBold
                        currencySymbol={companyCurrencySymbol}
                    />
                </strong>),
        },
    ];
};

export default {
    storageKey: StorageKey.report_aging_summary_receivable,
    getReportLabel: () => t`Aged Receivables Summary`,
    required: [
        'legal_name',
        'base_coming_due_amount',
        'base_total_amount',
    ],
    getColumns,
};
